import { createStore } from 'vuex';
import login from './modules/login';
import contacts from './modules/contacts';
import fairs from './modules/fairs';
import events from './modules/events';
import bookings from './modules/bookings';

export default createStore({
  state: {
    isOffline: false,
    isTesting: true,
		backPage: '',
    //apiPath: (process.env.NODE_ENV === 'development') ? '/api/' : 'https://www.coesiaevents.com/api/',
    apiPath: (process.env.NODE_ENV === 'development') ? 'http://127.0.0.1:80/App%20CoesiaEvents/api/' : 'https://www.coesiaevents.com/api/',
		packageVersion: process.env.PACKAGE_VERSION || '0'
  },
  mutations: {
    SET_OFFLINE(state, isOffline) {
      console.log(`setting ${isOffline ? 'offline' : 'online'}`)
      state.isOffline = isOffline
    },
    SET_TESTING(state, testing) {
      state.isTesting = testing
    },
    SET_BACKPAGE(state, backpage) {
			//console.log('SET backpage', backpage)
      state.backPage = backpage
    },
  },
  actions: {
    offline({ commit }, offline) {
      localStorage.setItem('offline',offline)
      commit('SET_OFFLINE', offline)
    },
    checkOffline({commit}){
      const isOffline=localStorage.getItem('offline')
      if (isOffline) commit('SET_OFFLINE',isOffline=='true')
    },
    testing({ commit }) {
      commit('SET_TESTING', false)
    },
    setBackpage({ commit }, backpage) {
      commit('SET_BACKPAGE', backpage)
    }
  },
  getters: {
    offlineMode: (state) => state.isOffline,
    testing: (state) => state.isTesting,
    apiPath: (state) => state.apiPath,
		appVersion: (state) => state.packageVersion,
		getBackpage: (state) => state.backPage
  },
  modules: {
    login,
    contacts,
    fairs,
    events,
    bookings,
  },
})
